var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Flashlight component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconFlashlight extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.34521 3.05141C6.39009 2.94299 6.45589 2.84448 6.53886 2.76151C6.62182 2.67854 6.72033 2.61274 6.82875 2.56787C6.93717 2.523 7.05378 2.49994 7.17112 2.5L16.8297 2.5C16.947 2.49994 17.0632 2.523 17.1716 2.56787C17.2801 2.61274 17.3786 2.67855 17.4615 2.76151C17.5445 2.84448 17.6103 2.94299 17.6552 3.05141C17.7001 3.15982 17.7231 3.27644 17.7231 3.39377V4.82166L6.27735 4.82166L6.27734 3.39335C6.27728 3.27602 6.30034 3.15982 6.34521 3.05141ZM6.27735 6.32166L6.27735 6.833L9.29294 9.8486C9.43359 9.98925 9.51261 10.18 9.51261 10.3789L9.51261 20.6016C9.51268 20.8383 9.60674 21.0654 9.77412 21.2328C9.94153 21.4002 10.1686 21.4942 10.4053 21.4943L13.5939 21.4954C13.8307 21.4954 14.0577 21.4013 14.2251 21.2339C14.3925 21.0665 14.4866 20.8395 14.4866 20.6028L14.4866 10.3801C14.4866 10.1812 14.5656 9.99041 14.7063 9.84976L17.7231 6.833V6.32166L6.27735 6.32166ZM5.4782 1.70085C5.25584 1.92321 5.07949 2.18721 4.95924 2.47777C4.83898 2.76832 4.77717 3.07973 4.77734 3.39419V7.14366C4.77734 7.34257 4.85636 7.53334 4.99702 7.67399L8.01261 10.6896L8.01261 20.6018C8.01271 21.2363 8.2648 21.8448 8.71346 22.2934C9.16212 22.7421 9.77061 22.9942 10.4051 22.9943L13.5941 22.9954C14.2286 22.9953 14.8371 22.7432 15.2858 22.2946C15.7344 21.8459 15.9865 21.2373 15.9866 20.6028L15.9866 10.6907L19.0034 7.67399C19.144 7.53334 19.2231 7.34257 19.2231 7.14366V3.39419C19.2232 3.07973 19.1614 2.76832 19.0412 2.47777C18.9209 2.18721 18.7446 1.92321 18.5222 1.70085C18.2998 1.4785 18.0358 1.30215 17.7453 1.18189C17.4549 1.06169 17.1432 0.999882 16.8289 1H7.17153C6.85707 0.999826 6.54566 1.06163 6.25511 1.18189C5.96455 1.30215 5.70055 1.4785 5.4782 1.70085Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconFlashlight.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconFlashlight.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconFlashlight.prototype, "size", void 0);
if (customElements.get('cat-icon-flashlight') === undefined) {
    customElements.define('cat-icon-flashlight', BlocksIconFlashlight);
}
